module.exports = __webpack_public_path__ + "img/p6-p1-yu4.4c089591.png";